'use client';

import { pushGtmEvent } from '@/lib/analytics/gtm';
import {
  GTM_DATA_LAYER_KEYS,
  GTM_EVENTS,
  type GtmEventName,
} from '@/lib/analytics/gtmEvents';

const FORM_SUCCESS_EVENTS: Record<string, GtmEventName> = {
  contact: GTM_EVENTS.CONTACT_US_FORM_SUBMISSION,
  doctorEnquiry: GTM_EVENTS.SUCCESSFUL_SEND_INQUIRY_FORM,
  serviceEnquiry: GTM_EVENTS.SUCCESSFUL_SEND_INQUIRY_FORM,
  careers: GTM_EVENTS.CAREERS_FORM_SUBMISSION,
  referral: GTM_EVENTS.REFERRAL_FORM_SUBMISSION,
};

export function pushFormSuccessGtmEvent(
  formId: string,
  metadata?: { doctorName?: string; serviceName?: string },
): void {
  const payload: Record<string, unknown> = {
    [GTM_DATA_LAYER_KEYS.PAGE_PATH]:
      typeof window !== 'undefined' ? window.location.pathname : undefined,
  };

  if (metadata?.doctorName) {
    payload[GTM_DATA_LAYER_KEYS.CHOSEN_DOCTOR] = metadata.doctorName;
  }

  const formEvent = FORM_SUCCESS_EVENTS[formId];
  if (formEvent) {
    pushGtmEvent(formEvent, payload);
  }

  pushGtmEvent(GTM_EVENTS.CONTACT_US_FORM_SUBMISSION, payload);
}
